/*
 * A class to centralize storage of pretty much anything such as text,
 * colors, styles, functions, etc. @param mixed init An object or array to
 * initialize the registry for convenience
 */
const Registry = function registerFBP (init) {

  // private var, an object to hold key=>value pairs
  let registry = {};
  if (init) {
  	if (init instanceof Object) {
  		registry = Object.assign({}, init);
  	} else if (init instanceof Array) {
  		for ( let i = 0; i++; i < init.length) {
  			registry[init[0]] = init[1];
  		}
  	}
  }

  // public methods
  this.setValue = function setRequestVal (name, value) {
  	let newValue;
  	if (value instanceof Object) {
  		newValue = Object.assign({}, value);
  	} else {
  		newValue = value;
  	}

  	registry[name] = newValue;
  };

  this.getValue = function getRequestVal (name) {
  	return registry[name];
  };

  // less verbose alias for getValue
  this.v = function returnVal (name) {
  	return this.getValue(name);
  };

};


const dedupInstance = new Registry;

export function getDedup() {
  return dedupInstance;
}